package ui.screens.editorial

import kotlinx.browser.window

actual fun openGoogleMaps(link: String) {
    window.open(link, "_blank")
}